// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".link-underline__inner[data-v-fcfd57ca]{position:relative;display:inline-block}.link-underline__line[data-v-fcfd57ca]{position:absolute;bottom:0;left:50%;width:calc(100% - 8px);height:1px;background-color:currentColor;opacity:0;transform:translateX(-50%);transition:opacity .3s,width .3s cubic-bezier(.425,.18,.2,.985)}.link-underline:hover .link-underline__line[data-v-fcfd57ca]{opacity:1;width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
